import { cn } from '../../../utils/utils';
import styles from './Alert.module.scss';

export const Alert: React.FC<{
  title?: string;
  message: string;
  type: 'error';
}> = ({ title, message, type }) => {
  return (
    <div className={cn(styles['root'], styles[type])}>
      {title && <h4>{title} </h4>}
      {message && (
        <ul>
          {message.split(';').map((s) => (
            <li>{s.trim()}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Alert;
